import { Skeleton } from '@access-erp/ui-components';

import styles from './predicted-actual-table.module.scss';

export interface ITableColumn {
  thCellStyle?: React.CSSProperties;
  tdCellStyle?: React.CSSProperties;
}

interface ITableSkeletonProps {
  tableColumns: ITableColumn[];
  skeletonRowCount?: number;
}

export default function PredictedActualTableSkeleton({
  tableColumns,
  skeletonRowCount = 5,
}: ITableSkeletonProps) {
  return (
    <div className={styles['table-skeleton']}>
      <div className={styles.row}>
        {tableColumns.map((column: ITableColumn, index: number) => (
          <div
            key={index}
            style={index === 0 ? column.thCellStyle : undefined}
            className={styles.col}
          >
            <Skeleton width="100%" />
          </div>
        ))}
      </div>

      {Array.from({ length: skeletonRowCount }).map((el, index: number) => (
        <div className={styles.row} key={index}>
          <div className={styles.col}>
            <Skeleton width="100%" />
          </div>
        </div>
      ))}
    </div>
  );
}
